import axios from "axios";
import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axiosFetch from "../../Helper/Axios";

export const Items = ({ prop, setLoading }) => {
  const [quantity, setQuantity] = useState(prop.quantity);
  const [item2, setItem2] = useState(prop.products);

  const onToast = () => {
    toast.success('Item Removed!!', {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const updateQuantity = async (q) => {
    const currentToken = sessionStorage.getItem("token");
    if (!currentToken) return;

    const prodId = prop.products?.productid || prop.products?.productId;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/addproduct`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + currentToken,
          },
          body: JSON.stringify({
            productId: prodId,
            quantity: q,
          }),
        }
      );

      if (res.ok) {
        const temp = await res.json();
        setLoading(temp);
      }
    } catch (err) {
      console.error("Error updating quantity:", err);
    }
  };

  const handleQuantity = (e) => {
    e.preventDefault();
    setQuantity(e.target.value);
    updateQuantity(e.target.value);
  };
  const handleMinus = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
      updateQuantity(quantity - 1);
    }
  };
  const handlePlus = () => {
    if (quantity > 0) {
      setQuantity(quantity + 1);
      updateQuantity(quantity + 1);
    }
  };

  const handleRemove = async () => {
    const currentToken = sessionStorage.getItem("token");
    if (!currentToken) return;

    const prodId = prop.products?.productid || prop.products?.productId;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/product/${prodId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + currentToken,
          },
        }
      );

      if (res.ok) {
        const t = await res.json();
        setLoading(t);
        onToast();
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  return (
    <>
      <tr>
        <th scope="row" className="border-0">
          <div className="p-2">
            <img
              src={`data:image/png;base64,${item2.img}`}
              alt=""
              width={70}
              className="img-fluid rounded shadow-sm d-inline "
            />
            <div className="ml-3 d-inline-block align-middle">
              <h5 className="mb-0">
                {" "}
                <a href="#" className="text-dark d-inline-block align-middle">
                  {item2.productName}
                </a>
              </h5>
              <span className="text-muted font-weight-normal font-italic d-block">
                Category: Watches
              </span>
            </div>
          </div>
        </th>
        <td className="border-0 align-middle">
          <strong>{item2.price}</strong>
        </td>
        <td className="border-0 align-middle">
          <div className="qty2 display-flex">
            <button className="qtyminus1" onClick={() => handleMinus()}>
              -
            </button>

            {/* <form  className="display-flex"> */}
            <input
              type="text"
              name="quantity"
              onChange={(e) => handleQuantity(e)}
              value={quantity}
              className="qty1"
            />
            {/* </form> */}
            <button className="qtyplus1" onClick={() => handlePlus()}>
              +
            </button>
          </div>
          {/* <div className="qtyminus">-</div>
                            <i class="fa-light fa-plus"/>
                            <strong>3</strong>
                            <div className="qtyplus">+</div> */}
        </td>
        <td className="border-0 align-middle">
          <a  className="text-dark" onClick={()=>handleRemove()}>
            <i className="fa fa-trash" />
          </a>
        </td>
      </tr>
    </>
  );
};
